import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_app/home")({
  component: Home,
})

function Home() {
  return <p>home</p>
}
